import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

import Dropdown from '../../../Dropdown';

const breadcrumbDropdownResponsive = media.phone`
  left: 15px;
  top: 15px;
`;

export const BreadcrumbDropdown = styled(Dropdown)`
  left: 0;
  right: auto;
  overflow-y: auto;
  ${breadcrumbDropdownResponsive};
`;

export const BreadcrumbDropdownContent = styled.div``;

export const BreadcrumbDropdownItem = styled.div`
  ${flexCenter};
  justify-content: flex-start;
  cursor: pointer;
  padding: 10px 20px;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
  &:before {
    content: '';
    width: 32px;
    height: 32px;
    display: block;
    background: url(${getFromCdn('images/dashboard/folder-small.svg')})
      no-repeat center transparent;
    flex-shrink: 0;
    margin-right: 14px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  &:hover {
    background: rgba(32, 171, 210, 0.1);
  }
`;

export default BreadcrumbDropdownContent;
